<div class="row" style="position: relative">
  <div
    style="position: absolute; top: 0px; right: 25px; z-index: 99999; cursor: pointer;"
    mat-button
    (click)="close()"
    class=""
    cdkFocusInitial
  >
    <i class="material-icons"> close </i>
  </div>
  <div class="col-md-12" style="overflow: hidden !important">
    <div class="card" style="height: 110%">
      <div class="card-header">
        <div class="row">
          <div class="col-md-12">
            <h4>Email</h4>
          </div>
        </div>
      </div>
      <div mat-dialog-content>
        <div class="card-body">
          <form #f="ngForm">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field class="example-chip-list">
                  <mat-label>To</mat-label>
                  <mat-chip-listbox #chipListTo aria-label="Fruit selection">
                    <mat-chip-option
                      *ngFor="let mail of body.to"
                      [ngClass]="{ 'not-mail': !validar(mail) }"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeTo(mail)"
                    >
                      {{ mail }}
                      <button
                        style="border: none; background: none"
                        matChipRemove
                        *ngIf="removable"
                      >
                        <i
                          class="fa fa-times-circle fa-lg"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </mat-chip-option>
                    <input
                      placeholder="Add mail..."
                      name="chipto"
                      [(ngModel)]="valueTo"
                      [matChipInputFor]="chipListTo"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="addTo($event)"
                    />
                  </mat-chip-listbox>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <mat-form-field class="example-chip-list">
                  <mat-label>CC</mat-label>
                  <mat-chip-listbox #chipListCC aria-label="Fruit selection">
                    <mat-chip-option
                      *ngFor="let mail of body.cc"
                      [ngClass]="{ 'not-mail': !validar(mail) }"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeCC(mail)"
                    >
                      {{ mail }}
                      <button
                        style="border: none; background: none"
                        matChipRemove
                        *ngIf="removable"
                      >
                        <i
                          class="fa fa-times-circle fa-lg"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </mat-chip-option>
                    <input
                      placeholder="Add mail..."
                      name="chipto"
                      [(ngModel)]="valueCC"
                      [matChipInputFor]="chipListCC"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="addCC($event)"
                    />
                  </mat-chip-listbox>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <mat-form-field class="example-chip-list">
                  <mat-label>BCC</mat-label>
                  <mat-chip-listbox #chipListBCC aria-label="Fruit selection">
                    <mat-chip-option
                      *ngFor="let mail of body.bcc"
                      [ngClass]="{ 'not-mail': !validar(mail) }"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="removeBCC(mail)"
                    >
                      {{ mail }}
                      <button
                        style="border: none; background: none"
                        matChipRemove
                        *ngIf="removable"
                      >
                        <i
                          class="fa fa-times-circle fa-lg"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </mat-chip-option>
                    <input
                      placeholder="Add mail..."
                      name="chipto"
                      [(ngModel)]="valueBCC"
                      [matChipInputFor]="chipListBCC"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="addBCC($event)"
                    />
                  </mat-chip-listbox>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <mat-form-field class="example-full-width">
                  <mat-label>Subject</mat-label>
                  <input matInput name="subject" [(ngModel)]="body.subject" />
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <ckeditor  name="mensaje" [(ngModel)]="body.msg" [editor]="Editor" [data]="body.msg"></ckeditor>
              </div>
            </div>

            <div class="atachmen">
              <div *ngFor="let item of attachmen; let i = index" class="item-atachmen">
                <i *ngIf="item.name.includes('.pdf')" style="margin-left: 10px; margin-right: 5px;" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                <i *ngIf="item.name.includes('.jpg') || item.name.includes('.png')" style="margin-left: 5px; margin-right: 5px;"  class="fa fa-file-image-o" aria-hidden="true"></i>
                <a class="link" (click)="goLink(item.file)">{{item.name}} ({{item.size}} Kb)</a>
                <i (click)="removeAtachmen(i)" style="margin-left: 5px; margin-right: 10px;"  class="fa fa-times-circle link" aria-hidden="true"></i>
              </div>
              &nbsp;
              <i *ngIf="loadingAtachmen" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </div>

          </form>
        </div>
      </div>

      <div class="card-footer">
        <div mat-dialog-actions>

          <button
            mat-button
            matDialogClose="no"
            (click)="close()"
            class="btn btn-default"
          >
            Close
          </button>

          <button
            mat-button
            class="btn btn-success"
            [disabled]="body.to.length === 0 || body.subject === '' || sending"
            (click)="send()"
          >
            <i
              *ngIf="sending"
              class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
            ></i>
            <i
              *ngIf="!sending"
              class="fa fa-paper-plane"
              aria-hidden="true"
            ></i>
            &nbsp; Send
          </button>

        </div>
      </div>
    </div>
  </div>
</div>
